import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useReduxHook = () => {
  const user = useSelector((state) => state.user);
  const userEmail = useMemo(() => user?.emailAddress, [user]);
  const isDevUser = useMemo(
    () =>
      user?.emailAddress === "joliva@cliffcomortgage.com" ||
      user?.emailAddress === "dev1@cliffcomortgage.com" ||
      user?.emailAddress === "dev@arrowservicing.com" ||
      user?.emailAddress === "dev1@arrowservicing.com" ||
      user?.emailAddress === "dev2@arrowservicing.com" ||
      user?.emailAddress === "shyrose@arrowservicing.com" ||
      user?.emailAddress === "ryanw@arrowservicing.com" ||
      user?.emailAddress === "cwolpert@cliffcomortgage.com",

    [user]
  );

  const isTempDevUser = useMemo(
    () =>
      user?.emailAddress === "joliva@cliffcomortgage.com" ||
      user?.emailAddress === "dev@arrowservicing.com" ||
      user?.emailAddress === "dev1@arrowservicing.com" ||
      user?.emailAddress === "dev2@arrowservicing.com" ||
      user?.emailAddress === "dev1@cliffcomortgage.com" ||
      user?.emailAddress === "cwolpert@cliffcomortgage.com" ||
      user?.emailAddress === "shyrose@arrowservicing.com" ||
      user?.emailAddress === "ryanw@arrowservicing.com" ||
      user?.emailAddress === "holden.hargrave@Lendmarq.com" ||
      user?.emailAddress === "holden.hargrave@lendmarq.com" ||
      user?.emailAddress === "cnguyen@cliffcomortgage.com",
    [user]
  );

  const isHighLevelUser = useMemo(
    () =>
      user?.emailAddress === "joliva@cliffcomortgage.com" ||
      user?.emailAddress === "dev@arrowservicing.com" ||
      user?.emailAddress === "dev1@arrowservicing.com" ||
      user?.emailAddress === "dev2@arrowservicing.com" ||
      user?.emailAddress === "dev1@cliffcomortgage.com" ||
      user?.emailAddress === "cwolpert@cliffcomortgage.com" ||
      user?.emailAddress === "shyrose@arrowservicing.com" ||
      user?.emailAddress === "ryanw@arrowservicing.com" ||
      user?.emailAddress === "holden.hargrave@Lendmarq.com" ||
      user?.emailAddress === "holden.hargrave@lendmarq.com" ||
      user?.emailAddress === "cnguyen@cliffcomortgage.com",
    [user]
  );

  const isAdmin = useMemo(() => {
    const permissions = user?.permissions || [];
    return permissions.includes("admin");
  }, [user]);

  return {
    user,
    userEmail,
    isTempDevUser,
    isDevUser,
    isHighLevelUser,
    isAdmin,
  };
};
